import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { DATA_ACCESS_LEVELS } from "@shared/utils/src/core/constants/DATA_ACCESS_LEVELS";

/**
 * @group Enums
@summary
<blockquote>PostgreSQL enum for data access levels</blockquote>
 * @internal
 */
export const dataAccessLevelEnum = pgEnumFromObject('data_access_level', DATA_ACCESS_LEVELS); 